import React from "react";
import { OurProcessBox } from "./styled";
import { Heading, Flex, Box, Text } from "@edricphan2022/uikit";
import ContentHeader from "../../components/ContentHeader";

interface OurProcessProps {
  getScrollToElementRef: any;
  ArrScrollService: any[];
}

const OurProcess: React.FC<OurProcessProps> = ({ getScrollToElementRef, ArrScrollService }) => {
  return (
    <OurProcessBox>
      {/* <ContentHeader text="" title="Our Process" /> */}
      <Box className="main" pt="40px">
        {ArrScrollService.map((item, index) => {
          return (
            <Flex key={`cus-${index}`} className="box-flex" pb="106px">
              <Flex justifyContent="center">
                {index === 2 ? (
                  <item.animation widthGroup="100px" heightGroup="100px" widthFloor="100px" heightFloor="100px" />
                ) : (
                  <item.animation width="150px" height="150px" />
                )}
              </Flex>
              <Flex className="faq-item" ref={getScrollToElementRef(item.name) as React.RefObject<HTMLDivElement>}>
                <Heading>{item.title}</Heading>
                <Box>
                  <Text className="content-about">{item.des}</Text>
                  <Flex className="faq-list">
                    {item.list?.map((_item: any, _index: any) => (
                      <Flex>
                        <span className="cus-line" />
                        <Text key={_index}>{_item.des}</Text>
                      </Flex>
                    ))}
                  </Flex>
                </Box>
              </Flex>
            </Flex>
          );
        })}
      </Box>
    </OurProcessBox>
  );
};

export default OurProcess;
